import { Injectable } from "@angular/core";
import { Analytics, getAnalytics, logEvent as firebaseLogEvent } from "firebase/analytics";
import { getApp, getApps, initializeApp } from "firebase/app";
import { environment } from "environments/environment";

@Injectable({
  providedIn: "root",
})
export class FirebaseAnalyticsService {
  private analytics: Analytics | null = null;

  ConversationTypes: { [x: string]: string } = {
    Chat: "chat",
    Group: "group",
    Case: "case",
    SelfChat: "self_chat",
  };

  constructor() {
    try {
      const app = getApps().length
        ? getApp()
        : initializeApp(environment.firebaseConfig);
      this.analytics = getAnalytics(app);
    } catch {
      this.analytics = null;
    }
  }

  logEvent(eventName: string, params?: { [key: string]: any }) {
    if (!this.analytics) return;
    firebaseLogEvent(this.analytics, eventName, params);
  }

  raiseEvent(event_name: string, params: { [key: string]: any } | undefined) {
    if (params) {
      params["app_version"] = environment.appVersion;
    }
    this.logEvent(event_name, params);
  }

  raisePageViewEvent(page_name: string, params?: { [x: string]: string }) {
    params = params ? params : {};
    params["page_name"] = page_name;
    this.raiseEvent("celo_page_view", params);
  }

  buttonClickEvent(button_id: any, params?: { [x: string]: any }) {
    params = params ? params : {};
    params["button_id"] = button_id;
    this.raiseEvent("button_click", params);
  }

  raiseLinkEvents(link_type: string, source: string) {
    this.raiseEvent("link_share", {
      link_type,
      source,
    });
  }

  raiseLinkResetEvents(link_type: string, success: boolean) {
    this.raiseEvent("link_reset", {
      link_type,
      success,
    });
  }

  getFormatedConversationType(conversationType: string) {
    if (!this.ConversationTypes[conversationType]) {
      return "";
    }
    return this.ConversationTypes[conversationType];
  }
}
